/* Carrinho gaveta: bloco "Add to your order" com produtos do mesmo time.
   Os cards vêm de sections/aura-cart-upsell.liquid, primeiro pela coleção do time do item
   do carrinho (achada em snippets/aura-cart-drawer-upsell.liquid, na ordem da coleção) e,
   se não houver time ou a coleção vier vazia, pela recomendação da própria Shopify.
   A gaveta é redesenhada a cada mudança de quantidade, então o resultado fica guardado
   na página (memória) e na sessão (10 min) para o bloco reaparecer na hora, sem piscar. */
if (!customElements.get('aura-cart-upsell')) {
  const CACHE_PREFIX = 'aura_cart_upsell_v1:';
  const CACHE_TTL = 10 * 60 * 1000;
  const memoryCache = new Map();
  const inflight = new Map();

  // redirect 'manual': coleção inexistente responde 301 para outra página, e seguir
  // esse redirecionamento traria cards que não são do time
  const fetchCards = (url) =>
    fetch(url, { redirect: 'manual' }).then((response) => {
      if (!response.ok) return '';
      return response.text().then((text) => {
        const track = new DOMParser().parseFromString(text, 'text/html').querySelector('.aura-upsell__track');
        return track && track.children.length ? track.innerHTML.trim() : '';
      });
    });

  class AuraCartUpsell extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.aura-upsell__track');
      this.prevButton = this.querySelector('.aura-upsell__arrow--prev');
      this.nextButton = this.querySelector('.aura-upsell__arrow--next');
      if (!this.track || !this.dataset.productId) return;

      const shopify = window.Shopify || {};
      this.cacheKey = [
        this.dataset.productId,
        this.dataset.collectionHandle || '',
        this.dataset.cartIds || '',
        (shopify.currency && shopify.currency.active) || '',
        shopify.locale || '',
      ].join('|');

      const cached = this.readCache();
      if (cached !== null) {
        this.render(cached);
      } else {
        this.load();
      }
    }

    readCache() {
      if (memoryCache.has(this.cacheKey)) return memoryCache.get(this.cacheKey);
      try {
        const raw = sessionStorage.getItem(CACHE_PREFIX + this.cacheKey);
        if (!raw) return null;
        const entry = JSON.parse(raw);
        if (!entry || Date.now() - entry.t > CACHE_TTL) return null;
        memoryCache.set(this.cacheKey, entry.h);
        return entry.h;
      } catch (e) {
        return null;
      }
    }

    writeCache(html) {
      memoryCache.set(this.cacheKey, html);
      try {
        sessionStorage.setItem(CACHE_PREFIX + this.cacheKey, JSON.stringify({ t: Date.now(), h: html }));
      } catch (e) {}
    }

    load() {
      const key = this.cacheKey;
      if (!inflight.has(key)) {
        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const sectionId = encodeURIComponent(this.dataset.sectionId || 'aura-cart-upsell');
        const productId = encodeURIComponent(this.dataset.productId);
        const handle = this.dataset.collectionHandle;
        const recommendationsUrl = `${root}recommendations/products?section_id=${sectionId}&product_id=${productId}&limit=10&intent=related`;

        const teamCards = handle
          ? fetchCards(`${root}collections/${encodeURIComponent(handle)}?section_id=${sectionId}`)
          : Promise.resolve('');
        const request = teamCards
          .then((html) => html || fetchCards(recommendationsUrl))
          .catch(() => null)
          .finally(() => inflight.delete(key));
        inflight.set(key, request);
      }

      inflight.get(key).then((html) => {
        // null = falha de rede: não guarda, tenta de novo no próximo desenho da gaveta
        if (html === null) return;
        this.writeCache(html);
        if (this.isConnected) this.render(html);
      });
    }

    render(html) {
      if (!html) {
        this.hidden = true;
        return;
      }
      this.track.innerHTML = html;
      this.hidden = false;
      this.bindArrows();
      this.updateArrows();
    }

    bindArrows() {
      if (this.arrowsBound) return;
      this.arrowsBound = true;
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByCards(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByCards(1));
      if ('ResizeObserver' in window) new ResizeObserver(() => this.updateArrows()).observe(this.track);
    }

    // A seta anda 2 cards por clique
    scrollByCards(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = (card.getBoundingClientRect().width + gap) * 2;
      this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    updateArrows() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (this.prevButton) this.prevButton.hidden = this.track.scrollLeft <= 2;
      if (this.nextButton) this.nextButton.hidden = this.track.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('aura-cart-upsell', AuraCartUpsell);
}
